import { FormikProps } from 'formik'
import React, { useRef } from 'react'
import Select from 'react-select'
import { getAllCountries } from 'requests/countries'

interface FormValues {
  gender: string
  birthDate: string
  countryOfBirthName: string
  countryOfBirthCode: string
  street: string
  city: string
  zipCode: string
  occupation: string
  transactionPerMonth: string

  numberTransactionsPerMonth: string
}
interface Props {
  formik: FormikProps<FormValues>
}

const ProfileStepOne: React.FC<Props> = ({ formik }) => {
  const birthDateInputRef = useRef<HTMLInputElement>(null)
  const getMaxBirthDate = () => {
    const date = new Date()

    date.setFullYear(date.getFullYear() - 18)

    return date.toISOString().split('T')[0]
  }

  const maxBirthDate = getMaxBirthDate()

  const TypeGender = [
    { value: 'male', label: 'Homme' },
    { value: 'female', label: 'Femme' },
  ]
  const paysNaissance = getAllCountries()

  return (
    <div className="flex flex-col sm:items-center gap-4 w-full">
      <h2 className="h2">Complétez votre profil</h2>
      <h3 className="text-[#AEB6FB] font-bold">Étape 1</h3>
      <p className="text-[#6B7280] text-[16px] lg:text-center">
        Nous avons besoin de vous connaître un peu plus.
      </p>
      <div className="h3">Vos Informations Personnelles</div>
      <div className="flex flex-col w-full">
        <Select
          classNamePrefix="select"
          isSearchable={false}
          placeholder="Genre"
          options={TypeGender}
          value={TypeGender.find((item) => item.value === formik.values.gender) || null}
          onChange={(option) => formik.setFieldValue('gender', option?.value || '', true)}
          onBlur={() => formik.setFieldTouched('gender', true, true)}
          getOptionValue={(option) => option.label}
          getOptionLabel={(option) => option.label}
        />

        <p className="text-[#EE443F] text-[10px] mt-1 h-[15px] sm:h-[10px] ">
          {formik.touched.gender && formik.errors.gender}
        </p>
      </div>

      <div className="w-full">
       <div className="flex items-center w-full placeholder:text-[#D1D1FF]  rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[48px] text-[#5754E5] text-[16px] px-[10px] ">
          <input
            ref={birthDateInputRef}
            className="outline-none w-full"
            type="date"
            name="birthDate"
            value={formik.values.birthDate}
            onChange={(event) => {
              formik.setFieldValue('birthDate', event.target.value, true)
            }}
            onBlur={formik.handleBlur}
            // max={maxBirthDate}
          />
          

          {/* Icône calendrier */}
          <svg
          onClick={() => {
            birthDateInputRef.current?.showPicker?.()
          }}
            className=" w-[22px] h-[22px] text-[#AEB6FB] cursor-pointer"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M7 2V5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            <path d="M17 2V5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            <rect x="3" y="4" width="18" height="17" rx="3" stroke="currentColor" strokeWidth="1.8" />
            <path d="M3 9H21" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        </div>

        <p className="text-[#EE443F] text-[10px] mt-1 h-[15px] sm:h-[10px]">
          {formik.touched.birthDate && formik.errors.birthDate}
        </p>
      </div>

      <div className="flex flex-col w-full">
        <Select
          classNamePrefix="select"
          isSearchable={false}
          placeholder="Pays de naissance"
          options={paysNaissance}
          value={paysNaissance.find((item) => item.frenshName === formik.values.countryOfBirthName) || null}
          onChange={(option) => {
            ;(formik.setFieldValue('countryOfBirthName', option?.frenshName || '', true),
              formik.setFieldValue('countryOfBirthCode', option?.code || '', false))
          }}
          onBlur={() => formik.setFieldTouched('countryOfBirthName', true, true)}
          getOptionValue={(option) => option.frenshName}
          getOptionLabel={(option) => option.frenshName}
        />
        <p className="text-[#EE443F] text-[10px] mt-1 h-[15px] sm:h-[10px]">
          {formik.touched.countryOfBirthName && formik.errors.countryOfBirthName}
        </p>
      </div>
    </div>
  )
}

export default ProfileStepOne
